module.exports = __webpack_public_path__ + "img/Everbright .1124b691.png";